
import { mapState, mapGetters } from 'vuex'
import cms from '~/mixins/common/cms'
export default {
    name: 'Theme3MobileFooter',
    mixins: [cms],
    data() {
        return {
            route: '/',
        }
    },
    computed: {
        ...mapState({
            isLogin: (state) => state.settings.isLogin,
        }),
        ...mapGetters({
            mobileGameWheelIcon: 'cms/mobileGameWheelIcon',
        }),
    },
    watch: {
        '$nuxt.$route.path'(value) {
            this.route = value
        },
    },
    mounted() {
        this.route = this.$nuxt.$route.path
    },
    methods: {
        isActive(route) {
            return this.route === route
        },
        clickCenterMenu() {
            this.$router.push('/')
        },
    },
}
